import React from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";

import { screens } from "../screens";
import { APP_ROUTES } from "../constants/app_routes";

const stack = createBrowserRouter([
  {
    path: "/",
    element: <screens.TabNavigator />,
  },
  {
    path: APP_ROUTES.AUTH,
    element: <screens.AuthScreen />,
  },
  {
    path: APP_ROUTES.LOGIN,
    element: <screens.SigInScreen />,
  },
  {
    path: APP_ROUTES.REGISTER,
    element: <screens.SignUpScreen />,
  },
  {
    path: APP_ROUTES.VERIFICATION,
    element: <screens.VerificationScreen />,
  },
  {
    path: APP_ROUTES.MY_TRADES,
    element: <screens.ProfileEdit />,
  },
  {
    path: APP_ROUTES.PROFILE,
    element: <screens.ProfileScreen />,
  },
  {
    path: APP_ROUTES.LANGUAGE,
    element: <screens.LanguageScreen />,
  },
  {
    path: APP_ROUTES.SETTINGS,
    element: <screens.SettingsScreen />,
  },
  {
    path: APP_ROUTES.WITHDRAW,
    element: <screens.WithdrawScreen />,
  },
  {
    path: APP_ROUTES.WITHDRAW_PASSWORD,
    element: <screens.WithdrawPasswordScreen />,
  },
  {
    path: APP_ROUTES.UPDATE_ACCOUNT,
    element: <screens.UpdateAccountScreen />,
  },
  {
    path: APP_ROUTES.UPDATE_PASSWORD,
    element: <screens.UpdatePasswordScreen />,
  },
  {
    path: APP_ROUTES.PERSONAL,
    element: <screens.PersonalScreen />,
  },
  {
    path: APP_ROUTES.SUPPORT,
    element: <screens.ChatScreen />,
  },
  {
    path: APP_ROUTES.TRANSACTIONS,
    element: <screens.TransactionsScreen />,
  },
]);

export const StackNavigator: React.FC = () => {
  return <RouterProvider router={stack} />;
};
